import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState = {};

export const sortedDataSlice = createSlice({
  name: 'sortedData',
  initialState,
  reducers: {
    sortedData: (state, action: PayloadAction<any>) => {
      state = action.payload;
      return state;
    },
  },
});

export const { sortedData } = sortedDataSlice.actions;

export default sortedDataSlice.reducer;
